import {
  MAIN_REASONS,
  SANCTION_TYPES,
  PROPOSAL_TYPES,
} from "../../../RecipientDetail/sanctionConstants";
import { PRESENCE_OPTIONS } from "./DecisionModalHelpers";

export const getReasonLabel = (reasonId) => {
  const reason = Object.values(MAIN_REASONS).find((r) => r.id === reasonId);
  return reason?.label || reasonId;
};

export const getSanctionTypeLabel = (type) => {
  return type === SANCTION_TYPES.SUSPENSION ? "Suspension" : "Suppression";
};

export const getSanctionTypeStyle = (type) => {
  return type === SANCTION_TYPES.SUSPENSION
    ? {
        bg: "#fef3c7",
        color: "#92400e",
        border: "#f59e0b",
        icon: "fa-pause-circle",
      }
    : {
        bg: "#fee2e2",
        color: "#991b1b",
        border: "#ef4444",
        icon: "fa-times-circle",
      };
};

export const getDetectionTypeBadge = (detectionType) => {
  const styles = {
    PREMIER: {
      bg: "#dbeafe",
      color: "#1e40af",
      border: "#3b82f6",
      label: "Premier manquement",
    },
    PERSISTANCE: {
      bg: "#fef3c7",
      color: "#92400e",
      border: "#f59e0b",
      label: "Persistance",
    },
    REITERATION: {
      bg: "#fee2e2",
      color: "#991b1b",
      border: "#ef4444",
      label: "Réitération",
    },
  };
  return styles[detectionType] || null;
};

export const isPresent = (presenceId) => {
  if (!presenceId) return false;
  return presenceId === "PRESENT" || presenceId === "PRESENT_ACCOMPAGNE";
};

export const getPresenceLabel = (presenceId) => {
  const opt = PRESENCE_OPTIONS.find((o) => o.id === presenceId);
  return opt?.label || presenceId;
};

export const getPresenceDisplay = (inscription) => {
  if (!inscription.presenceId) {
    return {
      color: "#94a3b8",
      bg: "#f1f5f9",
      label: "Non renseigné",
      icon: "fa-question-circle",
    };
  }
  if (isPresent(inscription.presenceId)) {
    return {
      color: "#16a34a",
      bg: "#f0fdf4",
      label: getPresenceLabel(inscription.presenceId),
      icon: "fa-check-circle",
    };
  }
  return {
    color: "#dc2626",
    bg: "#fef2f2",
    label: getPresenceLabel(inscription.presenceId),
    icon: "fa-times-circle",
  };
};

export const getProposalLabel = (proposalId) => {
  const proposal = Object.values(PROPOSAL_TYPES).find(
    (p) => p.id === proposalId,
  );
  return proposal?.label || proposalId;
};

export const isOver62 = (inscription) => {
  return (
    inscription.userRecipient?.age &&
    parseInt(inscription.userRecipient.age) > 62
  );
};
